import React, { useContext } from 'react';
import { useTranslation, Trans } from 'react-i18next';

import { DisplayComponent } from 'formlabs-web-components/BaseComponents';
import { Link } from 'formlabs-web-components/Link';

import ContactSalesForm from '../forms/ContactSalesForm';
import Modal from './Modal';

import countryContext from '../../context/country';

const ContactSales = ({
  linkText,
  displayType,
  buttonColor,
  buttonText,
  resellerVariant,
  buttonArrow
}) => {
  const { t } = useTranslation();
  const { path } = useContext(countryContext);

  return (
    <Modal
      id="contact-sales"
      type={displayType}
      color={buttonColor}
      arrow={buttonArrow}
      label={linkText}
      width={resellerVariant ? '700px' : '1200px'}
    >
      <ContactSalesForm
        title={t('Contact Sales')}
        resellerVariant={resellerVariant}
        buttonText={buttonText || t('Contact Sales')}
      />
      {resellerVariant && (
        <p>
          <Trans>
            By submitting this form, you agree to receive information from a
            Formlabs distribution partner about news and offers on 3D printing
            via email and phone and you allow Formlabs Inc. to share your
            contact data with the partner for this purpose. Further details can
            be found in our{' '}
            <Link to={`${path}privacy-policy/`}>Privacy Policy</Link>.
          </Trans>
        </p>
      )}
    </Modal>
  );
};

export default DisplayComponent(ContactSales);
